import config from '../config';

export default class ConsentCtrl {
  privacyPolicyUrl = config.PRIVACY_POLICY_URL;

  constructor(Authentication, $uibModalInstance) {
    'ngInject';

    Object.assign(this, { Authentication, $uibModalInstance });
  }

  async consent() {
    await this.Authentication.consent();
    this.$uibModalInstance.close();
  }
}
